<div class="dialog-container"> 
  <div class="language-mapper-panel">
    <span>Language Mapper Names</span>
    <ul>
      <li *ngFor="let mapper of languageMappers" (click)="onSelectMapper(mapper)">
        {{ mapper.language_mapper_name }}
      </li>
    </ul>
  </div>

  <div class="middle-section">
    <div style="text-align: right">
      <button mat-icon-button class="add-button" (click)="toggleLanguageDropdown()">
        <mat-icon style="height: 19px;">add</mat-icon> Add
      </button>
    </div>

    
    <div *ngIf="selectedMapper">
      <p><strong>Selected Mapper:</strong><br /> {{ selectedMapper.language_mapper_name }}</p>
    </div>

    <mat-form-field appearance="fill" *ngIf="isDropdownVisible && !selectedMapper" class="combo-box">
      <mat-label>Select Language</mat-label>
      <input type="text"
             matInput
             [matAutocomplete]="auto"
             [(ngModel)]="selectedLanguage"
             (input)="filterLanguages()">
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onLanguageChange()">
        <mat-option *ngFor="let language of filteredLanguages" [value]="language.template_name">
          {{ language.template_name }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <div *ngIf="selectedMapper || isDropdownVisible">
      <mat-form-field appearance="fill" class="languages-select">
        <mat-label>Languages</mat-label>
        <mat-select [(value)]="selectedLanguages" multiple>
          <mat-option *ngFor="let template of templateData" [value]="template.template_id">
            {{ template.template_name }} - <br /><strong>{{ template.template_language || '- No Language -' }}</strong>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>


    <!-- <div class="dialog-actions">
      <button mat-button class="save-button" (click)="onSave()">Save</button>
      <button mat-button class="cancel-button" (click)="onCancel()">Cancel</button>
    </div> -->
    <div class="button-container">
      <button class="save-button" (click)="onSave()">Save</button>
      <button class="cancel-button" (click)="onCancel()">Cancel</button>
  </div>
  </div>
</div>
